import { useTransformContext } from "react-zoom-pan-pinch";
import { useEffect } from "react";
import { useDragAndDrop } from "../../provider/drag-and-drop/DragAndDrop.hook.ts";

export const useTechnicalController = () => {
  const { transformState } = useTransformContext();
  const { setTransformState } = useDragAndDrop();

  useEffect(() => {
    setTransformState(transformState);
  }, [setTransformState, transformState]);
};
